import { z } from 'zod';
import { PORTAL_READINESS_SECTIONS, PORTAL_READINESS_SEVERITIES } from './portal.schemas';

export const WEB_EXPOSE_READINESS_ITEMS = [
  'NOT_ACTIVE',
  'WEB_ADDRESS_MISSING',
  'MARKETING_TEXT_MISSING',
  'NO_PUBLISHED_PHOTO',
  'BUYER_COMMISSION_MISSING',
  'COMMISSION_REENTRY_REQUIRED',
  'BUYER_COMMISSION_ABOVE_SELLER',
  'BUYER_COMMISSION_BELOW_SELLER',
  'GEG_CERTIFICATE_BASIS',
  'GEG_ENERGY_VALUE',
  'GEG_ENERGY_SOURCE',
  'GEG_YEAR_BUILT',
  'GEG_ENERGY_CLASS',
  'GMODG_CERTIFICATE_BASIS',
  'GMODG_PRIMARY_ENERGY_VALUE',
  'GMODG_ENERGY_CLASS',
  'GMODG_YEAR_BUILT',
  'GMODG_ENERGY_SOURCE',
  'CERTIFICATE_EXPIRED',
] as const;
export type WebExposeReadinessItemCode = (typeof WEB_EXPOSE_READINESS_ITEMS)[number];

export const WebExposeReadinessItemSchema = z.object({
  item: z.enum(WEB_EXPOSE_READINESS_ITEMS),
  severity: z.enum(PORTAL_READINESS_SEVERITIES),
  // Reuses the portal sections, so the dialog's „where it is edited" links are the existing ones.
  section: z.enum(PORTAL_READINESS_SECTIONS),
  validUntil: z.iso.date().nullable(),
});
export type WebExposeReadinessItem = z.infer<typeof WebExposeReadinessItemSchema>;

export const WebExposeReadinessResponseSchema = z.object({
  ready: z.boolean(),
  url: z.url().nullable(),
  items: z.array(WebExposeReadinessItemSchema),
});
export type WebExposeReadinessResponse = z.infer<typeof WebExposeReadinessResponseSchema>;

export const PublishWebExposeBodySchema = z.object({ showAddress: z.boolean() }).strict();
export type PublishWebExposeBody = z.infer<typeof PublishWebExposeBodySchema>;
